module.exports = __webpack_public_path__ + "img/br24.cc163ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br24.jpg
// module id = hZnG
// module chunks = 0